import Page from "@/components/layout/Page";

export default function Corporate() {
  return (
    <div className="min-h-screen overflow-hidden bg-gradient-to-b from-[#020817] via-[#04151F] to-[#020817] text-slate-50">
      <Page>
        <section className="w-full pb-24">
          <div className="max-w-[1280px] mx-auto px-6">
          <h1 className="text-[54px] leading-[1.1] font-bold mb-6 page-title-gradient">Corporate</h1>
          
          <div className="space-y-6 max-w-3xl">
            <p className="text-xl text-muted-foreground leading-relaxed">
              Enhance workplace wellbeing with sensory solutions for neurodivergent employees.
            </p>
            
            <p className="text-lg leading-relaxed">
              Samboards supports forward-thinking employers in creating inclusive workplaces where neurodivergent employees can thrive. Our sensory products provide discreet, professional tools for managing stress, maintaining focus, and supporting self-regulation in the workplace.
            </p>
            
            <p className="text-lg leading-relaxed">
              Many employees with ADHD, autism, anxiety, or other conditions benefit from having quiet fidget tools at their desk. Our products are designed to be silent and subtle - perfect for open-plan offices and professional environments where concentration and discretion are important.
            </p>
            
            <p className="text-lg leading-relaxed">
              As part of workplace adjustments and Access to Work provisions, Samboards can help employers meet their responsibilities under the Equality Act while supporting employee wellbeing and productivity. Our corporate kits can be provided as part of onboarding packages or workplace wellbeing initiatives.
            </p>
            
            <p className="text-lg leading-relaxed">
              Investing in sensory support tools demonstrates a commitment to neurodiversity inclusion and can help reduce workplace stress, improve focus, and create a more supportive environment for all employees.
            </p>
          </div>
        </div>
      </section>
      </Page>
    </div>
  );
}
